module.exports = __webpack_public_path__ + "img/sanhuiyike_icon (2).fc26d02a.png";